import React from "react";
import { CardElement } from "@stripe/react-stripe-js";

export default function CardElementContainer({
  cardElementOptions,
  customClassName,
  customStyle = {},
}) {
  return (
    <div
      className={`${customClassName || ""}`}
      style={{
        border: "1px solid #c8d3f6",
        borderRadius: "6px",
        height: "45px",
        lineHeight: "19px",
        padding: "12px",
        ...customStyle,
      }}
    >
      <CardElement options={{ ...cardElementOptions }} />
    </div>
  );
}
